export const index_name = process.env.GATSBY_ALGOLIA_INDEX_NAME;

export const currency = process.env.GATSBY_CURRENCY;
export const country = "Brighton";
export const defaultArea = process.env.GATSBY_DEFAULT_AREA ? process.env.GATSBY_DEFAULT_AREA : "London";
export const defaultArea_Slug = defaultArea.toLowerCase().replace(/ /g,'-');

export const defaultArea_Newhomes = process.env.GATSBY_DEFAULT_AREA_NEWHOMES ? process.env.GATSBY_DEFAULT_AREA_NEWHOMES : "London";
export const defaultArea_Newhomes_Slug = defaultArea_Newhomes.toLowerCase().replace(/ /g,'-');

export const defaultResult_Link = "/property/to-rent/in-"+defaultArea_Slug+"/";

export const site_name = process.env.GATSBY_SITE_NAME;
export const hasMyaccount = (process.env.GATSBY_MYACCOUNT || null) === '1' ? true : false;
export const postCodeAddressAPI = "ncZgV7m79UipxWpivISlAw37900";

export const IsAllAgentReview = true;
export const Default_View = "List"
export const slider_count = 3;

export const search_result_sidebar = true;

export const SimilarProperty_FullWdth = true;

export const branch_filter = true;


export const search_box_placeholder = "Enter a location e.g. Brighton or BN1";

export const footerVatDetails = "Brand Vaughan is the trading name of Cambridge Brand Vaughan Limited<br />and is registered in England & Wales<br />Registered office address: 70 St. Mary Axe, London, EC3A 8BE<br />Registered company number: 09467584. VAT Number: 213449231<br />Part of Lomond";

export const marketing_consent = `I agree to receive property-related news, updates and communications from Brand Vaughan. I understand I can unsubscribe at any time.`

export const Mail_Vars = {
    fb_link: "https://www.facebook.com/brandvaughanea/",
    tw_link: "https://twitter.com/brandvaughanea",
    company_phone: "0121 633 4455",
    available_time: "We're available from 9- 5pm Monday to Friday.",
    address: "Troy Mills, Troy Road, Horsforth, Leeds, LS18 5GN"
}

// export const PageLinks = {
//     about: "about-brandvaughan",
//     general_enquiry: "general-enquiry",
//     news_insight: `about-brandvaughan/insights`,
//     branch_finder: "about-brandvaughan/branch-finder",
//     area_cover: "about-brandvaughan/areas-we-cover",
//     branch_contact: "contact-us",
//     team_contact: "contact-us",
//     teams: "about-brandvaughan/meet-the-team",
//     request_valuation: "property-valuation",
//     privacy_policy: "privacy-policy",
//     book_a_viewing: "book-a-viewing",
//     book_a_valuation: "property-valuation/home-visit-valuation",
//     send_to_friend: "send-to-friend",
//     property_to_rent: "property/to-rent",
//     property_for_sale: "property/for-sale",
//     reviews: "about-brandvaughan/customer-reviews",
//     property_management: "landlords/property-management",
//     financial_services: `financial-services`
// }

export const PropertySearchURL = {
    residential: {
        sales:"/property/for-sale/",
        lettings:"/property/to-rent/",
        newhomes: "/new-homes/for-sale/",
        newdevelopments: "/new-developments/for-sale/",
        investments: "/property-investments/for-sale/",
        students: "/property-students/to-rent/",
        exceptional: "/property-exceptional/for-sale/",
    },
    commercial: {
        sales:"/commercial/for-sale/",
        lettings:"/commercial/to-rent/",
    },
    auction: {
        sales:"/auctions/for-sale/"
    }
}

export const PropertyDetailsURL = {
    residential: {
        sales:"/property-for-sale/",
        lettings:"/property-to-rent/",
        newhomes:"/property-for-sale/",
        newdevelopments:"/new-developments-for-sale/"
    },
    commercial: {
        sales:"/commercial-for-sale/",
        lettings:"/commercial-to-rent/",
    },
    auction: {
        sales:"/auction-for-sale/"
    }
}

export const SearchTitle = {
    residential: {
        sales:"Properties for sale",
        lettings:"Properties to rent",
        newhomes:"New homes",
        newdevelopments:"New developments",
        investments: "Investment properties for sale",
        students:"Student properties for sale",
        exceptional:"Exceptional homes for sale",
    },
    commercial: {
        sales:"Commercial properties for sale",
        lettings:"Commercial properties to rent",
    },
    auction: {
        sales:"Auction properties for sale"
    }
}

export const PopularSearch_Areas = [ 
    { value: "brighton", label: "Brighton" },
    { value: "hove", label: "Hove" },
    { value: "preston", label: "Preston" },
    { value: "worthing", label: "Worthing" }   
]

export const PopularSearch_Types = [ 
    { value: "house", label: "Houses" },
    { value: "apartment", label: "Apartments" },
    { value: "bungalow", label: "Bungalows" },
    { value: "maisonette", label: "Maisonettes" }   
]

export const sortByList = [ 
    { value: "Newest", label: "Newest" },
    { value: "Oldest", label: "Oldest" },
    { value: "HighestPrice", label: "Highest Price" },
    { value: "LowestPrice", label: "Lowest Price" }   
]

export const SearchType = {
    sales:"For Sale",
    lettings:"To Rent",
    newhomes:"New homes",
    investments:"Investments",
    students:"Students",
    commercial_sales:"Commercial Sales",
    commercial_lettings:"Commercial Lettings",
    auction_sales:"Auctions",
    exceptional:"Exceptional",
}

export const FurnishedType = [    
    { value: 'furnished', label: 'Furnished' },
    { value: 'unfurnished', label: 'Unfurnished' },
    { value: 'part-furnished', label: 'Part furnished' },
]

export const leadooPageSlot = {
    sell_property:"Sellers",
    landlords:"Landlords",
    sales:"Sale listings",
    lettings:"Rental listing",
    branch_finder:"Branch finder",
    general_enquiry:"General enquiry",
    valuation:"Valuation",
    home:"Valuation"
}